import { API_ENDPOINT } from '@/config/endpoint';
import { useQuery } from '@tanstack/react-query';

export const useGetStatisticsWithCategory = (category: string) => {
  return useQuery(['statistics', category], () =>
    API_ENDPOINT.statistics.getStatistics(category)
  );
};
